import { useState } from "react";

export default function AdSection() {

    const [random] = useState(() => Math.floor(Math.random() * 10) + 1);
    const adImage = "/assets/adPics/ad" + random + ".jpg";

    return (
        <div>
             {(random === 1 || random === 2) && (
            <div>
                <a href="https://share.google/InVzbCfg8c3TKYHhe" target="_blank" rel="noopener noreferrer">
                    <img
                        className="adImage"
                        src={adImage}
                        alt="Clickable Ad"
                        style={{ cursor: "pointer" }}
                    />
                </a>
                <p className="adText">Sponsored</p>
                <hr></hr>
            </div>
            )}
        </div>
    )
}